import { FxNulpunt, NulpuntGrafiek } from "../../../../content/wiskunde/1g_fx/nulpunt/exercises";
import { InteractiveNulpuntGraph1G } from "../../../../content/wiskunde/1g_fx/nulpunt/drawings";
import * as React from 'react';
export default {
  FxNulpunt,
  NulpuntGrafiek,
  InteractiveNulpuntGraph1G,
  React
};